import {
  AccordionData,
  BlogData,
  BulletsData,
  ButtonData,
  CalendarData,
  ChangeEvent,
  ContactFormData,
  ContentType,
  DocumentData,
  DSolutionsBadgeData,
  FoodMenuData,
  FormData,
  GalleryData,
  GridData,
  HeaderData,
  ImageCardsData,
  ImageCollageData,
  ImageData,
  LogoSectionData,
  OpeningHoursData,
  QuicklinksData,
  RichTextData,
  ServiceCardData,
  SponsorsData,
  TipsBoxData,
  TopSectionData,
  VideoHeroData,
  YtVideoData,
} from '@bm-js/atlascloud-shared'
import { useEditorActions, useEditorData } from '../../utils/hooks'
import GridEditor from '../GridEditor'
import HeaderEditor from '../HeaderEditor'
import ImageCardsEditor from '../ImageCardsEditor'
import RichTextEditor from '../RichTextEditor'
import BulletPointsEditor from '../BulletPointsEditor'
import LogoSectionEditor from '../LogoSectionEditor'
import ImageCollageEditor from '../ImageCollageEditor'
import ServiceCardEditor from '../ServiceCardEditor'
import ButtonEditor from '../ButtonEditor'
import ImageEditor from '../ImageEditor'
import GalleryEditor from '../GalleryEditor'
import FormEditor from '../FormEditor'
import VideoHeroEditor from '../VideoHeroEditor'
import TopSectionEditor from '../TopSectionEditor'
import QuickLinksEditor from '../QuickLinksEditor'
import AccordionEditor from '../AccordionEditor'
import TipsBoxEditor from '../TipsBoxEditor'
import DocumentEditor from '../DocumentEditor'
import BlogEditor from '../BlogEditor'
import CalendarEditor from '../CalendarEditor'
import ContactFormEditor from '../ContactFormEditor'
import SponsorEditor from '../SponsorEditor'
import YTVideoEditor from '../YTVideoEditor'
import { AnyObject } from '@naturalcycles/js-lib/types'
import DSolutionBadgeEditor from '../DSolutionBadgeEditor'
import FoodMenuEditor from '../FoodMenuEditor'
import OpeningHoursEditor from '../OpeningHoursEditor'

const EditorBarRightContent = () => {
  const { activeContent } = useEditorData()
  const { patchActiveContent } = useEditorActions()
  if (!activeContent) return null

  const setData = (e: ChangeEvent<unknown>) => {
    patchActiveContent({
      ...activeContent,
      data: {
        ...(activeContent.data as AnyObject),
        [e.target.name]: e.target.value,
      },
    })
  }

  switch (activeContent.name) {
    case 'grid':
      return (
        <GridEditor
          content={activeContent as ContentType<GridData>}
          setData={setData}
        />
      )
    case 'header':
      return (
        <HeaderEditor
          content={activeContent as ContentType<HeaderData>}
          setData={setData}
        />
      )
    case 'imageCards':
      return (
        <ImageCardsEditor
          content={activeContent as ContentType<ImageCardsData>}
          setData={setData}
        />
      )
    case 'richtext':
      return (
        <RichTextEditor
          content={activeContent as ContentType<RichTextData>}
          setData={setData}
        />
      )
    case 'bullets':
      return (
        <BulletPointsEditor
          content={activeContent as ContentType<BulletsData>}
          setData={setData}
        />
      )
    case 'logoSection':
      return (
        <LogoSectionEditor
          content={activeContent as ContentType<LogoSectionData>}
          setData={setData}
        />
      )
    case 'imageCollage':
      return (
        <ImageCollageEditor
          content={activeContent as ContentType<ImageCollageData>}
          setData={setData}
        />
      )
    case 'serviceCard':
      return (
        <ServiceCardEditor
          content={activeContent as ContentType<ServiceCardData>}
          setData={setData}
        />
      )
    case 'button':
      return (
        <ButtonEditor
          content={activeContent as ContentType<ButtonData>}
          setData={setData}
        />
      )
    case 'image':
      return (
        <ImageEditor
          content={activeContent as ContentType<ImageData>}
          setData={setData}
        />
      )
    case 'gallery':
      return (
        <GalleryEditor
          content={activeContent as ContentType<GalleryData>}
          setData={setData}
        />
      )
    case 'form':
      return (
        <FormEditor
          content={activeContent as ContentType<FormData>}
          setData={setData}
        />
      )
    case 'videoHero':
      return (
        <VideoHeroEditor
          content={activeContent as ContentType<VideoHeroData>}
          setData={setData}
        />
      )
    case 'topsection':
      return (
        <TopSectionEditor
          content={activeContent as ContentType<TopSectionData>}
          setData={setData}
        />
      )
    case 'quicklinks':
      return (
        <QuickLinksEditor
          content={activeContent as ContentType<QuicklinksData>}
          setData={setData}
        />
      )
    case 'accordion':
      return (
        <AccordionEditor
          content={activeContent as ContentType<AccordionData>}
          setData={setData}
        />
      )
    case 'tipsbox':
      return (
        <TipsBoxEditor
          content={activeContent as ContentType<TipsBoxData>}
          setData={setData}
        />
      )
    case 'document':
      return (
        <DocumentEditor
          content={activeContent as ContentType<DocumentData>}
          setData={setData}
        />
      )
    case 'blog':
      return (
        <BlogEditor
          content={activeContent as ContentType<BlogData>}
          setData={setData}
        />
      )
    case 'calendar':
      return (
        <CalendarEditor
          content={activeContent as ContentType<CalendarData>}
          setData={setData}
        />
      )
    case 'contactform':
      return (
        <ContactFormEditor
          content={activeContent as ContentType<ContactFormData>}
          setData={setData}
        />
      )
    case 'sponsors':
      return (
        <SponsorEditor
          content={activeContent as ContentType<SponsorsData>}
          setData={setData}
        />
      )
    case 'ytvideo':
      return (
        <YTVideoEditor
          content={activeContent as ContentType<YtVideoData>}
          setData={setData}
        />
      )
    case 'dSolutionsBadge':
      return (
        <DSolutionBadgeEditor
          content={activeContent as ContentType<DSolutionsBadgeData>}
          setData={setData}
        />
      )

    case 'foodMenu':
      return (
        <FoodMenuEditor
          content={activeContent as ContentType<FoodMenuData>}
          setData={setData}
        />
      )

    case 'openingHours':
      return (
        <OpeningHoursEditor
          content={activeContent as ContentType<OpeningHoursData>}
          setData={setData}
        />
      )
    default:
      return null
  }
}

export default EditorBarRightContent
